import { useMutation } from "@apollo/client";

import { CAMPAIGN_ACTION_TRACK } from "MVVM/GraphQL/campaignActionTrack";

/**
 * Campaign-tracked user actions that have no other server-side signal.
 * Mirrors the `CampaignAction` enum in beatles — each value maps to a gate
 * sonder stamps on the user's active campaign records.
 */
export type TCampaignAction = "CLIP_SHARED";

/**
 * Fire-and-forget hook for recording a campaign-tracked action (e.g. sharing a
 * clip) so sonder can stamp the matching activation-campaign gate. A failure is
 * swallowed so it can never block or surface to the user action that triggered it.
 */
export const useTrackCampaignAction = () => {
  const [trackCampaignActionMutation] = useMutation(CAMPAIGN_ACTION_TRACK);

  const trackCampaignAction = (action: TCampaignAction) => {
    trackCampaignActionMutation({
      variables: { input: { action } },
    }).catch(() => {
      // Intentionally ignored: gate stamping is best-effort and must never
      // interfere with the user's share.
    });
  };

  return { trackCampaignAction };
};
